import { render, staticRenderFns } from "./DefaultLoading.vue?vue&type=template&id=83f48ed0&scoped=true"
import script from "./DefaultLoading.vue?vue&type=script&lang=js"
export * from "./DefaultLoading.vue?vue&type=script&lang=js"
import style0 from "./DefaultLoading.vue?vue&type=style&index=0&id=83f48ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f48ed0",
  null
  
)

export default component.exports